import React, { Component } from 'react';
import '../../styles/components/status-tab.scss';
class StatusTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.selected || props.tabs?.[0]?.key,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.selected && nextProps.selected !== prevState.activeTab) {
      return { activeTab: nextProps.selected };
    }
    return null;
  }

  handleTabClick = (key) => {
    this.setState({ activeTab: key });

    if (this.props.onTabChange) {
      this.props.onTabChange(key);
    }
  };

  render() {
    const { activeTab } = this.state;
    const { tabs } = this.props;

    return (
      <div className="status-tabs-container">
        <div className="status-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
              onClick={() => this.handleTabClick(tab.key)}
            >
              {tab.icon && <tab.icon size={18} />}
              {tab.label}

              {/* Count Badge */}
              {typeof tab.count === 'number' && <span className="badge">{tab.count}</span>}
            </button>
          ))}
        </div>
      </div>
    );
  }
}

export default StatusTabs;
